import { render, staticRenderFns } from "./TaxDeclarations.vue?vue&type=template&id=9c858dd0&scoped=true"
import script from "./TaxDeclarations.vue?vue&type=script&lang=js"
export * from "./TaxDeclarations.vue?vue&type=script&lang=js"
import style0 from "./TaxDeclarations.vue?vue&type=style&index=0&id=9c858dd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c858dd0",
  null
  
)

export default component.exports